import { get, patch } from "./base";

const PayoutServ = {
  getSellerPayouts: (params) => get("/admin/payouts/sellers", { params }),
  updateSellerPayoutStatus: (orderId, payoutStatus, reason = null) => patch(`/admin/payouts/sellers/${orderId}`, { payoutStatus, reason }),
  getSellerPayoutDetails: (orderId) => get(`/admin/payouts/sellers/${orderId}`),

  getDeliveryPayouts: (params) => get("/admin/payouts/deliveries", { params }),
  updateDeliveryPayoutStatus: (deliveryId, payoutStatus, reason = null) => patch(`/admin/payouts/deliveries/${deliveryId}`, { payoutStatus, reason }),
  getDeliveryPayoutDetails: (deliveryId) => get(`/admin/payouts/deliveries/${deliveryId}`),

  getSellerOwnPayouts: (params) => get("/Orders/seller/payouts", { params }),
};

export default PayoutServ;
